import { Stack } from '@talos/kyoko';
import styled from 'styled-components';
import { Title } from '../../../../SymbolDisplay/styles';

export const PanelHeader = styled(Stack)`
  ${Title} {
    margin: 0;
  }
`;
PanelHeader.defaultProps = {
  gap: 'spacing2',
  h: 42,
  justifyContent: 'center',
  px: 'spacing8',
  overflow: 'hidden',
  borderBottom: '1px solid',
  borderColor: 'gray.000',
  flex: '0 0 auto',
};
